export default "__VITE_ASSET__Mv4Zx6d4__"